export const LOAD_INSENDIO_CAMPAIGNS = 'LOAD_INSENDIO_CAMPAIGNS';
export const LOAD_INSENDIO_CAMPAIGNS_SUCCESS = 'LOAD_INSENDIO_CAMPAIGNS_SUCCESS';
export const SET_INSENDIO_CAMPAIGN_VIEWED = 'SET_INSENDIO_CAMPAIGN_VIEWED';
